import { Select, Stack, Text } from "@shopify/polaris";
import { variantAttributes } from "../../../../../../../../../../constants/attributeTypes.js";

const AttributeSelectField = ({label, options, onChange, value}) => {
  return (
    <Stack vertical>
      <Select
        label={label}
        options={options}
        onChange={onChange}
        value={value}
      />
      {variantAttributes.includes(value) && <Text variant="headingXs" as="h6" color="critical">* The attribute that you have selected applies to variants. Note that this will hide/push not only specific variants but also the product as a whole.</Text>}
    </Stack>
  );
};

export default AttributeSelectField;